import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { Flex, Markdown } from '@applyboard/crystal-ui';
import { useScholarshipPageContext } from "../../contexts";
import { PageSectionTitle } from "../PageSectionTitle";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ScholarshipOverview = function ScholarshipOverview() {
  var _useScholarshipPageCo = useScholarshipPageContext(),
    scholarship = _useScholarshipPageCo.scholarship;
  return _jsxs(Flex, {
    direction: "column",
    gap: 2,
    children: [_jsx(PageSectionTitle, {
      title: "Overview"
    }), _jsx(Markdown, {
      headingSettings: {
        baseLevel: 5
      },
      markdown: scholarship.description
    })]
  });
};